import { createContext } from 'react';

const facturaContext = createContext();

export default facturaContext;